import useOutsideClick from "hooks/click-outside";
import React from "react";
import { AiOutlineClose } from "react-icons/ai";

interface BadgeData {
  image: string;
  name: string;
  conceptName: string;
  conceptDescription: string;
}

interface AwardedBadgeProps {
  isOpen: boolean;
  onClose: () => void;
  badgeData: BadgeData | null;
}

const AwardedBadge: React.FC<AwardedBadgeProps> = ({
  isOpen,
  onClose,
  badgeData,
}) => {
  const modalRef = useOutsideClick(onClose);
  if (!isOpen || !badgeData) return null;

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
      style={{ zIndex: 'calc(var(--z-modal) + 1)' }}
    >
      <div
        ref={modalRef}
        className={`relative bg-white px-6 py-6 rounded-2xl shadow-lg w-[90%] sm:w-[360px] transform transition-transform duration-300 ${
          isOpen ? "scale-100" : "scale-95"
        }`}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 transition"
        >
          <AiOutlineClose size={20} />
        </button>
        <h2 className="text-lg font-semibold text-gray-800 text-center mb-4">
          Awarded Badge
        </h2>

        {/* Badge Image */}
        <div className="mb-2">
          <img
            src={badgeData.image}
            alt={badgeData.name}
            className="w-32 h-32 object-contain mx-auto"
          />
        </div>
        <h2 className="text-lg font-semibold text-center text-primaryBlueText">
          {badgeData.name}
        </h2>
      </div>
    </div>
  );
};

export default AwardedBadge;
